import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.varnivisa.com';

export const SEO = ({ title, description, keywords, path = '/', image, schema }) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title ? `${title} | Varni Visa` : 'Varni Visa - Visa Consultant in Surat | Tour Packages & Travel';
  const desc = description || 'Premium visa consultancy, international tour packages, flight & hotel booking in Surat, Gujarat.';
  const img = image || `${SITE_URL}/og-image.jpg`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`
  }))
});

export const faqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a }
  }))
});

export const serviceSchema = (name, description, price) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name,
  description,
  provider: { '@type': 'TravelAgency', name: 'Varni Visa', url: SITE_URL },
  ...(price && { offers: { '@type': 'Offer', price, priceCurrency: 'INR' } })
});

export const touristTripSchema = (name, description, location) => ({
  '@context': 'https://schema.org',
  '@type': 'TouristTrip',
  name,
  description,
  touristType: 'Tourist',
  itinerary: { '@type': 'Place', name: location }
});

export default SEO;
